import axios, { AxiosRequestConfig } from 'axios';
import { storeInLocalStorage, updateLocalStorageList } from './LocalStorageService';

// Define the props for the service
interface SerializeAndSendPhotosProps {
  photos: string[]; // Array of photo files
  metadata?: {
    spread_type: string;
    matrix_size: string;
    layout: {
      position: string;
      card_name: string;
    }[];
    readingMode: string;
    focusArea: string;
    experienceLevel: string;
    question: string;
    notes: string;
  };
  context?: {
    readingMode: string;
    focusArea: string;
    experienceLevel: string;
    question: string;
    notes: string;
    spread_type: string;
    matrix_size: string;
    layout: {
      position: string;
      card_name: string;
    }[];
  };
}

interface TarotSpreadProps {
  cards: object;
  metadata?: {
    spread_type: string;
    matrix_size: string;
    layout: {
      position: string;
      card_name: string;
    }[];
    readingMode: string;
    focusArea: string;
    experienceLevel: string;
    question: string;
    notes: string;
  };
}

interface RecipesProps {
  ingredients: string[]; // Array of ingredients
}

// Service function
export const _getPhotoTarotReading = async ({
  photos,
  metadata
}: SerializeAndSendPhotosProps): Promise<void> => {
  const apiUrl = `${import.meta.env.VITE_API_URL}/api/tarot/photos`;


  const headers: AxiosRequestConfig['headers'] = {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  };

  try {
    const result = await axios.post(
      apiUrl,
      {
        photos,
        metadata
      },
      { headers }
    );
    const parsedResult = result.data; // cleanAndParseJSON(result.data);
    console.log(parsedResult);
    updateLocalStorageList('tarotReading', parsedResult);

    return result.data as any;
  } catch (error) {
    // Re-throw errors to be handled by the calling context
    throw error;
  }
};

export const _getTextTarotReading = async (metadata: TarotSpreadProps): Promise<void> => {
  const apiUrl = `${import.meta.env.VITE_API_URL}/api/tarot/text`;

  const headers: AxiosRequestConfig['headers'] = {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  };

  try {
    const result = await axios.post(
      apiUrl,
      metadata
      ,
      { headers }
    );

    updateLocalStorageList('tarotReading', { ...result.data });
    return result.data as any;
  } catch (error) {
    // Re-throw errors to be handled by the calling context
    throw error;
  }
};

export const _getReadings = async (): Promise<any> => {
  const apiUrl = `${import.meta.env.VITE_API_URL}/api/tarot/readings`;

  const headers: AxiosRequestConfig['headers'] = {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  };

  try {
    const result = await axios.get(apiUrl, { headers });
    return result.data;
  } catch (error) {
    // Re-throw errors to be handled by the calling context
    throw error;
  }
};

export const _getReadingById = async (id: string): Promise<any> => {
  const apiUrl = `${import.meta.env.VITE_API_URL}/api/tarot/readings/${id}`;

  const headers: AxiosRequestConfig['headers'] = {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
  };

  try {
    const result = await axios.get(apiUrl, { headers });
    return result.data;
  } catch (error) {
    // Re-throw errors to be handled by the calling context
    throw error;
  }
};

